import { Component } from '@angular/core';
import { MainAppService } from './services/main-app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(public mainAppService : MainAppService) {  }
  title = 'Zulu Bungy';
}
